import MintUI from './mint-ui'
import cookieTools from '../js/cookie'
export default {
  getUrlKey: function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2]); return null
  },
  alert: function (msg, duration=2000) {
    MintUI.Toast({
      message: msg,
      position: 'middle',
      duration: duration
    })
  },
  isWxLogin: function () {
    return localStorage.getItem('isWxLogin-cache') === 'true'
  },
  isWXUA: function () {
    var ua = navigator.userAgent.toLowerCase()
    if (/micromessenger/.test(ua)) {
      return true
    }
    return false
  },
  copy: function(src) {
    var dst = {};
    for (var prop in src) {
      if (src.hasOwnProperty(prop)) {
        dst[prop] = src[prop];
      }
    }
    return dst;
  },
  isMobileNum: function (str) {
    if ( str === undefined || str.length != 11) {
      return false
    }

    if(!(/^1[3|4|5|7|8][0-9]\d{4,8}$/.test(str))){
      return false
    }
    return true
  },
  isLogin: function () {
    var isLogin = localStorage.getItem('userIsLogin')
    console.log(localStorage.getItem('userIsLogin'))
    if (isLogin === 'true') {
      var loginTime = new Date(localStorage.getItem('userloginTime'))
      loginTime.setTime(loginTime.getTime()+24*60*60*1000);
      var nowTime = new Date()
      if (nowTime > loginTime) {
        localStorage.setItem('userIsLogin', false);
        localStorage.removeItem('loginCredentials');
        return false
      }
      else {
        return true
      }
    }
    else {
      return false
    }
  },
  delParama: function(key) {
    var search = window.location.search;
    var url = ''
    if (search.indexOf(key) != -1) {
      search = search.substring(1);
      var search_arr = search.split('&');
      var url_arr = [];
      for (var i = 0; i < search_arr.length; i++) {
        var temp = search_arr[i].split('=');
        if (key != temp[0]) {
          url_arr.push(search_arr[i]);
        }
      }
      url = window.location.pathname + '?' + url_arr.join('&');
    }
    window.history.pushState({},0,url);
    // window.location.href = url;
  }

}



// WEBPACK FOOTER //
// ./src/js/utils.js